import { AppBar, Box, Button, Dialog, DialogContent, Typography } from '@mui/material'
import { useDynamicSurveyPrefill } from '@common/hooks/useDynamicSurveyPrefill'
import 'survey-core/defaultV2.min.css'
import { Survey } from 'survey-react-ui'
import { Model } from 'survey-core'
import { useThemeContext } from '@common/theme'
import { darkTheme } from '@common/theme/surveyJSCustomDarkTheme'
import applyCustomClass from '@common/theme/surveyJSCustomDarkTheme'

type FormRendererDialogProps = {
  onClose: () => void
  header: string
  fields?: string | null
  values?: string | null
  readOnly?: boolean
  onSubmit: (params: Record<string, string | number | boolean>) => void
  defaultValues?: Record<string, string | number>
}

export default function FormRendererDialog({
  onClose,
  header,
  fields,
  onSubmit,
  values,
  readOnly,
  defaultValues,
}: FormRendererDialogProps) {
  const prefilledSurveyJson = useDynamicSurveyPrefill(
    {
      elements: (() => {
        try {
          if (typeof fields === 'string') {
            return JSON.parse(fields || '[]')
          } else if (fields) {
            return fields
          }
          return []
        } catch (error) {
          console.error('Error parsing eForm fields:', error)
          return []
        }
      })(),
    },
    defaultValues || {},
  )

  const survey = new Model(prefilledSurveyJson)
  const { themeMode } = useThemeContext()
  applyCustomClass(themeMode)
  if (themeMode === 'dark') {
    survey.applyTheme(darkTheme)
  }

  if (values) {
    try {
      survey.data = typeof values === 'string' ? JSON.parse(values) : values
    } catch (error) {
      console.error('Error parsing eForm values:', error)
    }
  }
  if (readOnly) {
    survey.mode = 'display'
  }

  survey.onComplete.add((sender) => {
    onSubmit(sender.data)
  })
  return (
    <Dialog fullScreen open={true} onClose={() => null}>
      <AppBar sx={{ position: 'relative', bgcolor: 'paper.main' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
          <Typography variant="subtitle1" color="text.primary" ml={1} data-testid="heading">
            {header}
          </Typography>
          <Box display="flex">
            <Button variant="text" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Box>
      </AppBar>
      <DialogContent sx={{ p: 0 }}>
        <Survey model={survey} />
      </DialogContent>
    </Dialog>
  )
}
